function ModalHandler($rootScope, $scope, $uibModal) {
    var modals = {};
    var modalsStack = [];
    var UseMinVersion = false;
    return {
        open: function (modalName, windowClass, backdrop, callbacks) {
            var templateUrl = getTemplateUrl(modalName);
            if (modals[templateUrl] == null || typeof modals[templateUrl] == 'undefined') {
                if (backdrop == null || backdrop == undefined)
                    backdrop = true;
                if (callbacks == null || callbacks == undefined)
                    callbacks = {};
                modals[templateUrl] = $uibModal.open({
                    templateUrl: templateUrl,
                    scope: $scope,
                    windowClass: windowClass,
                    backdrop: backdrop
                });
                modalsStack.push(modalName);
                modals[templateUrl].result.then((function () {
                    if (callbacks.resolvedCallback != undefined)
                        callbacks.resolvedCallback();
                }), (function () {
                    if (callbacks.rejectedCallback != undefined)
                        callbacks.rejectedCallback();
                }));
                // Is resolved when a modal is closed and the animation completes.
                modals[templateUrl].closed.then(function (data) {
                    modalsStack.pop();
                    modals[templateUrl] = undefined;
                    if (callbacks.finallyCallback != undefined)
                        callbacks.finallyCallback();
                })
                return true;
            } else return false;
        },
        close: function (modalName) {
            var templateUrl = getTemplateUrl(modalName);
            if (modals[templateUrl] != null && typeof modals[templateUrl] != 'undefined')
                modals[templateUrl].close('close');
        },
        dismiss: function (modalName) {
            var templateUrl = getTemplateUrl(modalName);
            if (modals[templateUrl] != null && typeof modals[templateUrl] != 'undefined')
                modals[templateUrl].dismiss();
        },
        isOpen: function (modalName) {
            var templateUrl = getTemplateUrl(modalName);
            if (modals[templateUrl] == null || typeof modals[templateUrl] == 'undefined') return false;
            return true;
        },
        setLoading: function (modalName, loading) {
            var templateUrl = getTemplateUrl(modalName);
            if (loading)
                modals[templateUrl] = 'loading'; //just so it isn't undefined
            else modals[templateUrl] = undefined;
        },
        isActive: function (modalName) {
            //return activeModal === modalName;
            return modalsStack[modalsStack.length - 1] == modalName;
        }
    }

    function getTemplateUrl(modalName) {
        return 'Templates/Modals/' + modalName + (UseMinVersion ? '.min' : '') + '.html?v=' + $rootScope.DoohConfig.version;
    }
}